export default __webpack_public_path__ + "static/media/before@3x.b6820d75.png";